var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import nanoid from "nanoid";
import axios from "axios";
class MessageBus {
  constructor(appIFrame = window) {
    this.appIFrame = appIFrame;
    this.allowedOrigin = "*";
    this.resolvers = new Map();
    this.commercePlatformWindow = appIFrame.parent;
    appIFrame.addEventListener("message", this.messageHandler.bind(this), false);
  }
  send(cmd, body, options = {}) {
    const payload = __spreadProps(__spreadValues({}, options), {
      id: nanoid(),
      cmd,
      body: body || options.body || ""
    });
    this.commercePlatformWindow.postMessage(JSON.stringify(payload), this.allowedOrigin);
    return new Promise((resolve, reject) => {
      this.resolvers.set(payload.id, { resolve, reject });
    });
  }
  subscribe(topicName, onMessage) {
    this.resolvers.set(topicName, { resolve: onMessage });
    return () => {
      this.resolvers.delete(topicName);
    };
  }
  setAllowedOrigin(allowedOrigin) {
    this.allowedOrigin = allowedOrigin;
  }
  messageHandler(event) {
    const hasData = typeof event.data === "string";
    const isFromCP = event.source === this.commercePlatformWindow;
    if (hasData && isFromCP) {
      let parsedData = null;
      try {
        parsedData = JSON.parse(event.data);
      } catch (err) {
        console.error(err);
      }
      if (parsedData && this.resolvers.has(parsedData.id)) {
        const resolver = this.resolvers.get(parsedData.id);
        if (parsedData.error && resolver.reject) {
          resolver.reject(parsedData.error);
        } else {
          resolver.resolve(parsedData.body);
        }
        this.resolvers.delete(parsedData.id);
      }
      if (parsedData && this.resolvers.has(parsedData.topicName)) {
        const resolver = this.resolvers.get(parsedData.topicName);
        resolver.resolve(parsedData.body);
      }
    }
  }
}
var EnvironmentOptions;
(function(EnvironmentOptions2) {
  EnvironmentOptions2["test"] = "test";
  EnvironmentOptions2["preprod"] = "preprod";
  EnvironmentOptions2["prod"] = "prod";
})(EnvironmentOptions || (EnvironmentOptions = {}));
function isGlobalContextObject(globalContext) {
  if (typeof globalContext === "object" && !Array.isArray(globalContext) && globalContext !== null) {
    if (globalContext.env !== void 0 && globalContext.orgId !== void 0) {
      return true;
    }
  }
  return false;
}
class CommercePlatform {
  constructor(overrides) {
    this.messageBus = new MessageBus();
    this.cancelSubscription = null;
    if (overrides == null ? void 0 : overrides.messageBusAllowedOrigin) {
      this.messageBus.setAllowedOrigin(overrides.messageBusAllowedOrigin);
      return;
    }
    void this.getEnvironment().then((env) => {
      const urlPrefix = env === "prod" ? "" : `${env}.`;
      const [, , domain] = document.referrer.split("/");
      switch (domain) {
        case "test.workbench.spscommerce.com":
        case "workbench.spscommerce.com":
          this.messageBus.setAllowedOrigin(`https://${urlPrefix}workbench.spscommerce.com`);
          break;
        case "devalpha.commerce.spscommerce.com":
          this.messageBus.setAllowedOrigin("https://devalpha.commerce.spscommerce.com");
          break;
        case "localhost:9300":
          this.messageBus.setAllowedOrigin("https://localhost:9300");
          break;
        case "localhost:9310":
          this.messageBus.setAllowedOrigin("https://localhost:9310");
          break;
        default:
          this.messageBus.setAllowedOrigin(`https://${urlPrefix}commerce.spscommerce.com`);
          break;
      }
    });
  }
  setPageTitle(title) {
    return this.messageBus.send("setPageTitle", { title: title || false });
  }
  getGlobalContext() {
    return this.messageBus.send("getGlobalContext").then((c) => isGlobalContextObject(c) ? c : null);
  }
  subscribeToGlobalContext(onChange) {
    if (typeof this.cancelSubscription === "function")
      this.cancelSubscription();
    this.cancelSubscription = this.messageBus.subscribe("GlobalContextChange", (c) => isGlobalContextObject(c) ? onChange(c) : onChange(null));
    return this.cancelSubscription;
  }
  setGlobalContext(globalContext) {
    return this.messageBus.send("setGlobalContext", globalContext);
  }
  openContactForm(targetReceiver) {
    if (targetReceiver) {
      return this.messageBus.send("openContactForm", targetReceiver);
    }
    return this.messageBus.send("openContactForm");
  }
  updateState() {
    return this.messageBus.send("appStateChange", {
      path: window.location.href.split("#")[1]
    });
  }
  showSpinner() {
    return this.messageBus.send("spinnerShow");
  }
  hideSpinner() {
    return this.messageBus.send("spinnerHide");
  }
  showNavigation() {
    return this.messageBus.send("navigationShow");
  }
  hideNavigation() {
    return this.messageBus.send("navigationHide");
  }
  showErrorPage(error) {
    return this.messageBus.send("showErrorPage", error);
  }
  getAppBaseUrl() {
    return this.messageBus.send("getAppBaseUrl");
  }
  getEnvironment() {
    return this.messageBus.send("getEnvironment");
  }
  getCurrentUrl() {
    return this.messageBus.send("getCurrentUrl");
  }
  trackIntercomEvent(event) {
    return this.messageBus.send("trackIntercomEvent", event);
  }
  showIntercom() {
    return this.messageBus.send("showIntercom");
  }
  showNewIntercomMessage() {
    return this.messageBus.send("newIntercomMessage");
  }
  getAppIconPath() {
    return this.messageBus.send("getAppIconPath");
  }
  goToUrl(url) {
    return this.messageBus.send("goToUrl", url);
  }
}
class IdentityService {
  constructor(apiService, environment) {
    this.apiService = apiService;
    this.environment = environment;
  }
  me() {
    return this.apiService.get(this.uri("identity/users/me"));
  }
  getUserById(userId) {
    return this.apiService.get(this.uri(`identity/users/${userId}`));
  }
  uri(path) {
    return this.environment === "prod" ? `https://id.spsc.io/${path}` : `https://${this.environment}.id.spsc.io/${path}`;
  }
}
class SpsApiService {
  constructor(token) {
    let foundToken = token;
    if (!foundToken) {
      foundToken = window.localStorage.getItem("access_token");
    }
    if (!foundToken) {
      foundToken = window.sessionStorage.getItem("token");
    }
    if (!foundToken && window.location.search) {
      const queryString = window.location.search.slice(1);
      if (queryString) {
        const tokenParam = queryString.split("&").map((param) => param.split("=")).find(([key]) => key === "access_token");
        if (tokenParam) {
          [, foundToken] = tokenParam;
        }
      }
    }
    if (!foundToken) {
      throw new Error("No Identity token was provided and none could be found. A token is required to call SPS APIs.");
    }
    this.authorization = { Authorization: `Bearer ${foundToken}` };
  }
  get(uri, headers, options) {
    return this.request("get", uri, headers, options);
  }
  post(uri, data, headers, options) {
    return this.request("post", uri, headers, options, data);
  }
  put(uri, data, headers, options) {
    return this.request("put", uri, headers, options, data);
  }
  patch(uri, data, headers, options) {
    return this.request("patch", uri, headers, options, data);
  }
  delete(uri, headers, options) {
    return this.request("delete", uri, headers, options);
  }
  request(method, uri, headers = {}, options = {}, data) {
    const patchedOptions = __spreadProps(__spreadValues({}, options), {
      headers: __spreadValues(__spreadValues({}, headers), this.authorization)
    });
    return data ? axios[method](uri, data, patchedOptions) : axios[method](uri, patchedOptions);
  }
}
export { CommercePlatform, EnvironmentOptions, IdentityService, MessageBus, SpsApiService, isGlobalContextObject };
